// Panel / zone auto-detection for the vehicle inspection diagrams.
// Coordinates are normalised (0..1) relative to each diagram.

// ---- Exterior (unfolded 5-view line drawing, 736 x 1119, front at bottom) ----
export function detectExteriorPanel(x, y) {
  if (y >= 0.87) return "Front Bumper";
  if (y <= 0.12) return "Rear Bumper / Boot";
  if (x < 0.30) return y < 0.45 ? "Rear Left Panel" : "Front Left Panel";
  if (x > 0.70) return y < 0.45 ? "Rear Right Panel" : "Front Right Panel";
  if (y < 0.24) return "Rear Windscreen";
  if (y < 0.42) return "Roof";
  if (y < 0.54) return "Windscreen";
  return "Bonnet";
}

// ---- Interior (programmatic top-down schematic, RIGHT-HAND DRIVE, front at top) ----
// Bird's-eye view, front pointing up: car's right (driver, RHD) is on the RIGHT of screen.
export const INT_VB_W = 620;
export const INT_VB_H = 1143;

// Detection zones as normalised rectangles {x, y, w, h, label}.
export const INTERIOR_ZONES = [
  { x: 0.10, y: 0.03, w: 0.80, h: 0.20, label: "Headliner" },
  { x: 0.12, y: 0.26, w: 0.76, h: 0.09, label: "Dashboard" },
  { x: 0.52, y: 0.27, w: 0.22, h: 0.09, label: "Steering Wheel" },
  { x: 0.17, y: 0.36, w: 0.28, h: 0.18, label: "Front Left Seat" },
  { x: 0.55, y: 0.36, w: 0.28, h: 0.18, label: "Front Right Seat" },
  { x: 0.15, y: 0.56, w: 0.30, h: 0.14, label: "Rear Left Seat" },
  { x: 0.55, y: 0.56, w: 0.30, h: 0.14, label: "Rear Right Seat" },
  { x: 0.45, y: 0.36, w: 0.10, h: 0.34, label: "Floor" },
  { x: 0.12, y: 0.71, w: 0.76, h: 0.22, label: "Boot" },
];

export function detectInteriorPanel(x, y) {
  let best = null, bestDist = Infinity;
  for (const z of INTERIOR_ZONES) {
    if (x >= z.x && x <= z.x + z.w && y >= z.y && y <= z.y + z.h) return z.label;
    const cx = z.x + z.w / 2, cy = z.y + z.h / 2;
    const d = (x - cx) ** 2 + (y - cy) ** 2;
    if (d < bestDist) { bestDist = d; best = z.label; }
  }
  return best || "Interior";
}
